export const showUsernameError = (message:string, suggestion: string) => {
	const messageErrEl = document.getElementById('message-error');
	const suggestionEl = document.getElementById('suggestion');
	const suggestionContainerEl = document.getElementById('suggestion-container');

	messageErrEl.closest('div').classList.remove('hidden');
	messageErrEl.innerText = message;
	if(suggestion.length > 0){
		suggestionContainerEl.classList.remove('hidden');
		suggestionEl.innerText = suggestion;
	}
}
